import { Injectable } from '@angular/core';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';
import { IndexedDbService } from '../../shared/services/indexedDb.service';
import { map } from 'rxjs/operators';
import { DataService } from '../../shared/services';

@Injectable()
export class TimeCounterPluginFactoryService extends InspectionFactoryService {
  constructor(indexedDb: IndexedDbService, dataService: DataService) {
    super(indexedDb, dataService);
  }

  public updateTimeCounter(inspectionId: string, pointId: string, pluginId: string, data: any) {
    if (this.isManager) {
      return this.dataService.getPlugin(inspectionId, pluginId).pipe(
        map((plugin) => {
          if (plugin) {
            plugin.config.Hours = data.Hours;
            plugin.config.Minutes = data.Minutes;
            return plugin;
          }
        })
      );
    }
    return this.getInspection(inspectionId).pipe(
      map((inspection) => {
        const plugin = inspection.allPlugins.find((p) => p.id === pluginId);
        if (plugin) {
          plugin.config.Hours = data.Hours;
          plugin.config.Minutes = data.Minutes;
          plugin.etag = new Date();
          this.updateInspection(inspection);
          return plugin;
        }
        return null;
      })
    );
  }
}
